import TrendingChart from './TrendingChart';

export default TrendingChart;
